import { Node, mergeAttributes } from '@tiptap/core';

// Pagination treats each question as one measured block, including its diagram
// and working area. These remain editable and are preserved in saved JSON.
export const QuestionBlock = Node.create({
  name: 'questionBlock', group: 'block', content: 'block+', defining: true,
  parseHTML: () => [{ tag: 'section[data-question]' }],
  renderHTML: ({ HTMLAttributes }) => ['section', mergeAttributes(HTMLAttributes, { 'data-question': '', class: 'worksheet-question' }), 0],
});
export const AnswerSection = Node.create({
  name: 'answerSection', group: 'block', content: 'block+', defining: true,
  addAttributes: () => ({ start: { default: true } }),
  parseHTML: () => [{ tag: 'section[data-answer-key]' }],
  renderHTML: ({ HTMLAttributes }) => ['section', mergeAttributes(HTMLAttributes, { 'data-answer-key': '', class: 'worksheet-answers' }), 0],
});

export const WorksheetHeading = Node.create({
  name: 'worksheetHeading', group: 'block', content: 'inline*', defining: true,
  parseHTML: () => [{ tag: 'h1[data-worksheet-title]' }],
  renderHTML: ({ HTMLAttributes }) => ['h1', mergeAttributes(HTMLAttributes, { 'data-worksheet-title': '', class: 'worksheet-print-title' }), 0],
});

export const QuestionRow = Node.create({
  name: 'questionRow', group: 'block', content: 'questionBlock{2,3}', defining: true,
  parseHTML: () => [{ tag: 'section[data-question-row]' }],
  renderHTML: ({ HTMLAttributes }) => ['section', mergeAttributes(HTMLAttributes, { 'data-question-row': '', class: 'worksheet-question-row' }), 0],
});
